import React from 'react';
import styles from './ServiceComponent.module.css';

const ServiceComponent = ({ title, descriptionPoints, imageSrc }) => {
  return (
    <div className={styles.serviceContainer}>
      <div className={styles.serviceContent}>
        <h2 className={styles.serviceTitle}>{title}</h2>
        <ul className={styles.serviceDescription}>
          {descriptionPoints.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
      <div className={styles.serviceImage}>
        <img src={imageSrc} alt={title} />
      </div>
    </div>
  );
};

export default ServiceComponent;
